module.exports = __webpack_public_path__ + "img/notification.29229f16.svg";